query GetBotInfo {
  bot: StreamToolsGetBotInfo {
    userId
    login
    displayName
    scopes
    connectedAt
    needsReauth
    lastRevocationReason
    lastRevocationAt
  }
}
